import { useQuery } from '@tanstack/react-query'

import { useDebounce } from '@hooks/useDebounce'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  MIN_QUERY_SIZE,
  initialState,
} from '../services/fetchContactpersoonAccounts'
import { fetchContactpersoonFilterAccounts } from '../services/fetchContactpersoonFilterAccounts'

export { useContactpersoonFilterAccounts }

const MAX_SUGGESTIONS = 5

const useContactpersoonFilterAccounts = ({ text }: { text: string }) => {
  const { hasPermissions } = useAuthenticatedUser()
  const debouncedText = useDebounce(text.trim())

  const { data } = useQuery({
    queryFn: () => fetchContactpersoonFilterAccounts({ text: debouncedText }),
    queryKey: ['contactpersoonFilterAccounts', debouncedText],
    enabled: hasPermissions,
  })

  // De debounce vertraagt alleen het zoeken; te korte tekst wist direct
  // de resultaten.
  return {
    data:
      text.trim().length < MIN_QUERY_SIZE
        ? initialState.data
        : (data || initialState.data).slice(0, MAX_SUGGESTIONS),
  }
}
